import React from 'react';
import propTypes from 'prop-types';

export const DirectCustomerIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 412.596 412.596"
      enableBackground="new 0 0 412.596 412.596"
      // style="enable-background:new 0 0 412.596 412.596;"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M85.333,223.153c32.837,0,59.553-26.715,59.553-59.551c0-32.83-26.715-59.54-59.553-59.54
     c-32.836,0-59.551,26.71-59.551,59.54C25.782,196.439,52.497,223.153,85.333,223.153z"
        />
        <path
          d="M122.46,213.799c-1.988-1.121-4.485-0.754-6.067,0.893l-31.058,32.387l-31.06-32.387c-1.581-1.648-4.079-2.017-6.067-0.893
     c-14.284,8.064-26.349,20.601-34.891,36.253C4.605,266.018,0,284.511,0,303.533c0,2.762,2.239,5,5,5h160.671c2.761,0,5-2.238,5-5
     c0-19.022-4.605-37.516-13.318-53.481C148.81,234.4,136.744,221.863,122.46,213.799z"
        />
        <path
          d="M327.259,223.153c32.837,0,59.553-26.715,59.553-59.551c0-32.83-26.715-59.54-59.553-59.54
     c-32.836,0-59.551,26.71-59.551,59.54C267.708,196.439,294.422,223.153,327.259,223.153z"
        />
        <path
          d="M399.277,250.052c-8.542-15.652-20.607-28.189-34.892-36.253c-1.988-1.121-4.486-0.754-6.067,0.893l-31.058,32.387
     l-31.061-32.387c-1.581-1.648-4.078-2.017-6.066-0.893c-14.284,8.064-26.349,20.601-34.891,36.253
     c-8.712,15.966-13.317,34.459-13.317,53.481c0,2.762,2.239,5,5,5h160.671c2.761,0,5-2.238,5-5
     C412.596,284.511,407.99,266.018,399.277,250.052z"
        />
        <path
          d="M164.926,184.536h65.845l-12.501,12.5c-2.734,2.734-2.734,7.166,0,9.9c1.367,1.366,3.158,2.05,4.95,2.05
     s3.583-0.684,4.95-2.05l24.45-24.45c2.734-2.734,2.734-7.166,0-9.899l-24.45-24.451c-2.732-2.733-7.165-2.733-9.899-0.001
     c-2.734,2.734-2.734,7.166,0,9.899l12.501,12.502h-65.845c-3.866,0-7,3.134-7,7C157.926,181.402,161.06,184.536,164.926,184.536z"
        />
        <path
          d="M181.825,242.06h65.845c3.866,0,7-3.134,7-7s-3.134-7-7-7h-65.845l12.501-12.5c2.734-2.734,2.734-7.166,0-9.9
     c-2.733-2.732-7.166-2.732-9.899,0l-24.45,24.45c-2.734,2.734-2.734,7.166,0,9.899l24.45,24.451
     c1.367,1.367,3.158,2.051,4.95,2.051c1.791,0,3.583-0.684,4.95-2.05c2.734-2.734,2.734-7.166,0-9.899L181.825,242.06z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
DirectCustomerIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
DirectCustomerIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
